import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./screens/HomePage.js";
import Header from "./header/Header.js";
import About from "./screens/About.js";
import Products from "./screens/Products.js";
import ProductDetail from "./screens/ProductDetails.js";
import Bags from "./screens/Bags.js";
import BagDetail from "./screens/BagDetails.js";
import Misc from "./screens/Misc.js";
import MiscDetail from "./screens/MiscDetails.js";
import Contact from "./screens/Contact.js";
import Footer from "./screens/Footer.js";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="about" element={<About />} />
        <Route path="products" element={<Products />} />
        <Route path="/products/:productSlug" element={<ProductDetail />} />
        <Route path="bags" element={<Bags />} />
        <Route path="/bags/:productSlug" element={<BagDetail />} />
        <Route path="misc" element={<Misc />} />
        <Route path="/misc/:productSlug" element={<MiscDetail />} />
        <Route path="contact" element={<Contact />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
